export default __webpack_public_path__ + "static/media/cc.56ae1a64.png";